module.exports = __webpack_public_path__ + "static/img/base_two.3d61ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/base_two.png
// module id = Rhks
// module chunks = 1